export default __webpack_public_path__ + "static/media/fullscreen.81f4c385.svg";